import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ImmigrationWizardContainerComponent } from './immigration-wizard-container/immigration-wizard-container.component';
// import { PetitionerInfoComponent } from '../bulk-upload/petitioner-info/petitioner-info.component';
import { LcaDetailsComponent } from './lca-details/lca-details.component';
import { JobDescriptionComponent } from './job-description/job-description.component';
import { IndividualDetailsComponent } from './individual-details/individual-details.component';
import { SocCodeComponent } from './soc-code/soc-code.component';
import { ReviewAnalyzePetitionDetailsComponent } from './review-analyze-petition-details/review-analyze-petition-details.component';
import { UscisContentComponent } from './uscis-content/uscis-content.component';
import { SubmitRecieptComponent } from './submit-reciept/submit-reciept.component';
import { GenerateLettersComponent } from './generate-letters/generate-letters.component';
import { EmployerEmployeeRelationshipComponent } from './employer-employee-relationship/employer-employee-relationship.component';
import { EducationDetailsComponent } from './education-details/education-details.component';
import { ItineraryOfServicesComponent } from './itinerary-of-services/itinerary-of-services.component';
import { SendFormsForSignatureComponent } from './send-forms-for-signature/send-forms-for-signature.component';

const routes: Routes = [
  {
    path: 'upload',
    component: ImmigrationWizardContainerComponent,
    children: [
      {
        path: 'lca-details',
        pathMatch: 'full',
        component: LcaDetailsComponent
      },
      {
        path: 'job-descrtiption',
        pathMatch: 'full',
        component: JobDescriptionComponent
      },
      {
        path: 'individual-details',
        pathMatch: 'full',
        component: IndividualDetailsComponent
      },
      {
        path: 'soc-code',
        component: SocCodeComponent,
        children: [
          {
            path: 'lca',
            loadChildren: () => import('../lca/lca.module').then((mod) => mod.LCAModule),
          }
        ]
      },
      {
        path: 'analyse-review',
        component: ReviewAnalyzePetitionDetailsComponent
      }, 
      {
        path: 'send-forms-signature',
        component: SendFormsForSignatureComponent
      },
      {  
        path: '', 
        pathMatch: 'full',       
        redirectTo: 'individual-details'
      },
      {
        path: 'submit-petition',
        pathMatch: 'full',
        component: SubmitRecieptComponent
      },
      {
        path: 'uscis-content',
        component: UscisContentComponent,
      },
      {
        path: 'generate-letters',
        component: GenerateLettersComponent
      },
      {
        path: 'employer-employee-relationship',
        component: EmployerEmployeeRelationshipComponent
      },
      {
        path: 'education-details',
        component: EducationDetailsComponent
      },
      {
        path: 'itinerary-of-services',
        component: ItineraryOfServicesComponent
      }
    ]
  },
  {
    path: '',
    redirectTo: 'upload'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class ImmigrationWizardRoutingModule { }
